module.exports = __webpack_public_path__ + "img/view-icon.24a1484d.svg";